import React from "react";
import { NavLink } from "react-router-dom";
import Header9 from "./../Common/Header9";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import ShopSidebar from "../Elements/ShopSidebar";

const products = [
  {
    image: require("./../../images/blog/event_2.jpg"),
    title: "COMMUNIQUE Projet Vallée Val d’OR II",
    description:
      "Dans le cadre du renforcement de ses actions de communication, le bureau de l’Association la vallée a le plaisir d’informer ses adhérents et membres bénéficiaires du programme « Vallée Val d’Or II »...",
    sale: "yes",
    date: "2020-10-31",
  },
  {
    image: require("../../images/annonces/image1.jpg"),
    title: "COMMUNIQUE Projet Vallée Val d’OR I",
    description:
      "Dans le cadre du renforcement de ses actions de communication, le bureau de l’Association la vallée a le plaisir d’informer ses adhérents et membres bénéficiaires du programme « Vallée Val d’Or II »...",
    sale: "yes",
    date: "2022-09-25",
  },
];

var bnrimg = require("../../images/banner/banner.jpg");

class ShopList extends React.Component {
  render() {
    return (
      <>
        <Header9 />
        <div className="page-content">
          <Banner
            title="Mes Actualités"
            pagename="Mes Actualités"
            bgimage={bnrimg}
          />
          {/* SHOP SECTION START */}
          <div className="section-full p-t120 p-b90 bg-white mobile-page-padding">
            <div className="container">
              {/* <div className="product-filter-wrap d-flex justify-content-between align-items-center m-b30">
                <div className="list-grid-control">
                  <NavLink to={"/shop-grid"}>
                    <i className="fa fa-th" />
                  </NavLink>
                  <NavLink to={"/shop-list"} className="active">
                    <i className="fa fa-th-list" />
                  </NavLink>
                </div>
                <span className="woocommerce-result-count">
                  Showing 1–10 of 13 results
                </span>
                <form
                  className="woocommerce-ordering select-box-border-style1-wrapper"
                  method="get"
                >
                  <select
                    name="orderby"
                    className="orderby select-box-border-style1"
                    aria-label="Shop order"
                  >
                    <option value="menu_order" selected="selected">
                      Default sorting
                    </option>
                    <option value="popularity">Sort by popularity</option>
                    <option value="rating">Sort by average rating</option>
                    <option value="date">Sort by latest</option>
                    <option value="price">Sort by price: low to high</option>
                    <option value="price-desc">
                      Sort by price: high to low
                    </option>
                  </select>
                  <input type="hidden" name="paged" defaultValue={1} />
                </form>
              </div> */}
              <div className="row d-flex justify-content-center">
                <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 m-b30">
                  <div className="shop-item-list-wrap-outer">
                    {products.map((item, index) => (
                      <div key={index} className="shop-item-list-wrap m-b30">
                        <div className="sx-box sx-product-box   overflow-hide">
                          {`${item.sale}` === "yes" ? (
                            <div className="shop-pro-sale-bnr">New!</div>
                          ) : (
                            ""
                          )}
                          <div className="sx-thum-bx">
                            <img src={item.image} alt="" />
                          </div>
                          <div className="sx-info">
                            <h5 className="sx-title">
                              <a href={"/annonces/valle-val-or-1"}>
                                {item.title}
                              </a>
                            </h5>
                            <span className="price">
                              <ins>
                                <span>
                                  <span className="Price-currencySymbol"></span>
                                  {item.date}
                                </span>
                              </ins>
                            </span>
                            <p>{item.description}</p>
                          </div>
                          <div className="sx-post-readmore">
                            <a
                              href={"/annonces/valle-val-or-1"}
                              title="Voir Plus"
                              rel="bookmark"
                              className="site-button-link"
                            >
                              Voir Plus
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="text-center">
                    <ul className="pagination-st-1 m-t30 m-b0">
                      <li>
                        <NavLink to={"#"}>
                          <span className="fa fa-chevron-left" />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"#"}>1</NavLink>
                      </li>
                      <li className="active">
                        <NavLink to={"#"}>2</NavLink>
                      </li>
                      <li>
                        <NavLink to={"#"}>3</NavLink>
                      </li>
                      <li>
                        <NavLink to={"#"}>
                          <span className="fa fa-chevron-right" />
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* SIDE BAR START */}
                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 sticky_column  m-b30">
                  <ShopSidebar />
                </div>
                {/* SIDE BAR END */}
              </div>
            </div>
          </div>
          {/* SHOP SECTION END */}
        </div>

        <Footer />
      </>
    );
  }
}

export default ShopList;
